import styled, { css } from 'styled-components'

export const BreadCrumbContainer = styled.li`
  position: relative;
  display: inline-block;
`

export const BreadCrumbTrigger = styled.button<{ isLastCrumb: boolean }>`
  position: relative;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;

  font: normal normal normal 12px/15px Inter;
  font-weight: ${props => (props.isLastCrumb ? 'bold' : 'normal')};
  color: ${props => props.theme.colors.color6b7786};

  transition: all 100ms ease-in-out;

  &:focus-visible {
    text-decoration: underline;
  }

  ${props =>
    props.isLastCrumb
      ? null
      : css`
          &:hover {
            text-decoration: underline;
          }
          &:active {
            border: 1px solid ${props => props.theme.colors.color6b7786};
          }
        `}
`
